import React from "react";
import Aboutcmdmessage from "../components/Aboutus/Aboutcmdmessage";
import Banner from '../comman/Banner/Banner';


const Aboutcmd = () => {
  return (
    <>
      <Banner
        index={'about-5'}
      />
      <Aboutcmdmessage />
    </>

  )
};

export default Aboutcmd;